import { Link } from "react-router-dom";
import MarketingLayout from "@/components/MarketingLayout";
import SEO from "@/components/SEO";

const SECTIONS = [
  ["1. The basics", "By creating a Nestled account you agree to these terms. If you don't, please don't sign up."],
  ["2. Your account", "Keep your password secret. You're responsible for what happens under your account. Tell us at contact@nestledapp.io if you suspect someone else has access."],
  ["3. Acceptable use", "Don't store illegal content. Don't try to break, abuse, or reverse-engineer the service. Don't impersonate other people. Don't upload photos you don't have the right to share with your household."],
  ["4. Subscriptions and billing", "Pro and Family plans are billed monthly via Stripe. You can cancel any time — your subscription stays active until the end of the current billing period. We don't issue refunds for partial months unless required by law."],
  ["5. Family plans", "The owner of a Family plan is responsible for who they invite. Members can leave at any time."],
  ["6. Content ownership", "Your data is yours. You grant us a limited licence only to host, transmit, and display your content within the product. We never claim ownership."],
  ["7. Service availability", "We do our best to keep Nestled running, but we can't promise 100% uptime. Scheduled maintenance happens occasionally; we'll give notice when we can."],
  ["8. Termination", "You can close your account any time. We can suspend or terminate accounts that violate these terms — usually after a warning, unless the violation is severe."],
  ["9. Liability", "Nestled is provided 'as is.' We're not liable for indirect, incidental, or consequential damages. The maximum amount you can ever recover from us is what you've paid in the last 12 months."],
  ["10. Changes", "We may update these terms. If we change anything material, we'll email you and post a notice in the app."],
  ["11. Contact", "Questions? contact@nestledapp.io"],
];

export default function Terms() {
  return (
    <MarketingLayout>
      <SEO
        title="Terms of service"
        description="Nestled's terms of service. Account rules, subscriptions, content ownership, liability, and contact info."
        path="/terms"
      />
      <section className="max-w-3xl mx-auto px-6 md:px-10 pt-16 md:pt-20 pb-16">
        <span className="text-xs font-bold uppercase tracking-[0.18em] text-terracotta-600">Last updated: Feb 2026</span>
        <h1 className="mt-3 font-heading text-4xl sm:text-5xl text-stoneink-900 font-semibold tracking-tight">Terms of service</h1>
        <p className="mt-5 text-stoneink-700 leading-relaxed">Plain English where we can. Lawyers later, if needed.</p>

        <div className="mt-12 space-y-8">
          {SECTIONS.map(([h, body]) => (
            <div key={h}>
              <h2 className="font-heading text-xl text-stoneink-900 font-medium tracking-tight">{h}</h2>
              <p className="mt-2 text-stoneink-700 leading-relaxed">{body}</p>
            </div>
          ))}
        </div>

        <p className="mt-12 text-stoneink-500 text-sm">
          See also our <Link to="/privacy" className="text-terracotta-600 hover:text-terracotta-700">privacy policy</Link>.
        </p>
      </section>
    </MarketingLayout>
  );
}
